import { _ } from "libs";

import React from "react";
import { RatingActivity } from "../../types";
import { formatName } from "../../libs/formatName";
// import { openPlayerPopup } from "../../actions";
import PlayerItemSmall from "../items/player/small";
import RatingItemChange from "../items/rating/change";

const OwnRatingUpdate = ({ activities }: { activities: RatingActivity[] }) => {
	if (!Array.isArray(activities) || activities.length === 0) {
		return null;
	}
	const activity = activities[0];
	const rating = activity.rating;
	const player = activity.actor.data;
	return (
		<div className="nBlock fixedHeader">
			<h5>
				{_("timeline.ownFederationRatingUpdate.heading", null, {
					federationName: activity.rating.federationName,
				})}
			</h5>
			<div className={`myRatingChange ${activity.rating.ratingChange}`}>
				<div className="content">
					<div className="user">
						<PlayerItemSmall
							name={formatName(player.firstName, player.lastName)}
							photoUrl={player.photoUrl}
						/>
					</div>
					<div className="rating">
						<RatingItemChange
							federationCode={activity.rating.federationCode}
							currentRating={activity.rating.classificationCategory}
							previousRating={activity.rating.lastClassificationCategory}
							ratingChange={activity.rating.ratingChange}
							className="large white center"
						/>
					</div>
					<div className="verifiedRatingLabel white">
						<div className="icon" />
						{_("player.skill.ratingVerifiedBy", null, { federationName: rating.federationName })}
					</div>
				</div>
				<div className="image">
					<div className="aspectFill"></div>
				</div>
			</div>
		</div>
	);
};

export default OwnRatingUpdate;
